
export function thum(page) {
	let boxPos;
	let sa;
	let move1;
	let move2;
	let move3;
	let durationTime = 0.6;


	/*--------------------------------
	サムネイルを増やす
	--------------------------------*/


	const workThumLists = Array.from(document.getElementsByClassName('workThumList'));
	//console.log(workThumLists);

	workThumLists.forEach((element) => {
		//console.log(element);
		let content = element.innerHTML;
		element.innerHTML = content + content + content;
	});
/*
	const box = document.getElementById('workThumListBox');
	const box1 = document.getElementById('workThumList01');
	const box2 = document.getElementById('workThumList02');
	const box3 = document.getElementById('workThumList03');





	document.addEventListener('scroll', () => {
		//console.log(this.winScrollTop);

		boxPos = box.getBoundingClientRect().top + window.pageYOffset;
		sa = page.winScrollTop + page.h - boxPos;
		//console.log(sa);

		move1 = (-sa / page.h) * 20;
		move2 = (sa / page.h) * 10 - 25;
		move3 = (-sa / page.h) * 30;

		//move1 = move1 % 100;

		//console.log(move1);

		//console.log(percent1);
		gsap.killTweensOf(box1);
		gsap.killTweensOf(box2);
		gsap.killTweensOf(box3);

		gsap.to(box1, {
			x: move1 + '%', // x軸方向に500px移動する
			duration: durationTime, // 3秒間アニメーションする
			delay: 0, // 3秒後にアニメーションする
			//ease: Power4.easeOut, // アニメーションの変化率をPower4.easeOutにする
			ease: 'none',
		});

		gsap.to(box2, {
			x: move2 + '%', // x軸方向に500px移動する
			duration: durationTime, // 3秒間アニメーションする
			delay: 0, // 3秒後にアニメーションする
			//ease: Power4.easeOut, // アニメーションの変化率をPower4.easeOutにする
			ease: 'none',
		});

		gsap.to(box3, {
			x: move3 + '%', // x軸方向に500px移動する
			duration: durationTime, // 3秒間アニメーションする
			delay: 0, // 3秒後にアニメーションする
			//ease: Power4.easeOut, // アニメーションの変化率をPower4.easeOutにする
			ease: 'none',
		});


	});
*/
}
